<template>
  <div class="inner" >
    <div>
      <h1>Bien joué !</h1>
    </div>
    <div id="obtained" class="centercenter" style="text-align: center">
        <div class="flexwrap centercenter">
          <div class="lightGoldTheme marginRound mediumRoundAngles">
            <div class="paddingRound">{{ this.goldStars }} <i class="fas fa-star" style="font-size: 80%;"></i></div>
          </div>
          <div class="lightSilverTheme marginRound  mediumRoundAngles">
            <div class="paddingRound">{{ this.silverStars }} <i class="fas fa-star" style="font-size: 80%"></i></div>
          </div>
          <div class="lightCopperTheme marginRound  mediumRoundAngles">
            <div class="paddingRound">{{ this.bronzeStars }} <i class="fas fa-star" style="font-size: 80%"></i></div>
          </div>
        </div>
      <br/>
      <div>Tu as obtenu <span style="font-weight: bold">50pts</span> !</div>

    </div>
    <div class="profileCardTheme bigPaddingRound mediumRoundAngles withBorder" id="calendarcard"
         v-if="!(profile.datas.studying_monday||profile.datas.studying_tuesday||profile.datas.studying_wednesday||
         profile.datas.studying_thursday||profile.datas.studying_friday||profile.datas.studying_saturday||
         profile.datas.studying_sunday)" style="margin-top: 1vw">
      <div>Fixe toi un objectif, pour penser à venir régulièrement !</div>
      <div class="simpleGrid">
        <div class="calendar">
          <div v-for="id in [0, 1, 2, 3, 4, 5, 6]" :key="id" class="studyingDay flexwrap centercenter clickable"
               :class="{selected : daySelected(id)}"
               @click="toggleDay(id)"
          >
            {{dayNames(id)}}
          </div>
        </div>

        <toggle v-model="tempProfile.reminders_ok">Recevoir des rappels en cas d'oubli</toggle>
      </div>
    </div>
    <div style="opacity: 0.5; text-align: center;" v-else><div>~ Ce n'est pas grâve si tu ne comprends pas tout ! C'est avec le temps passé en immersion dans la série que tu progresseras ! ~</div></div>
    <!--<standard-button @click="returnToMenu()" :color-class="'blue'"> Partager <span class="tilePoints">+15pts</span> </standard-button>-->
    <standard-button @click="returnToMenu()" :color-class="'blue'"> Terminer </standard-button>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {API_URL} from "@/App";
import {lock} from "@/main";
import axios from "axios";

export default {
  name: "vocabularyRecapCard",
  components: {StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue'),
    Toggle: () => import(/* webpackPrefetch: true */ '@/components/toggle.vue')},
  created() {
    // Gère les changements temporaires (pas encore validées) des infos de l'utilisateur
    this.tempProfile = Object.assign({}, this.profile.datas);

    for (let i = 0; i < this.learntWords.length; i++) {
      if (this.learntWords[i].lemma.user_lemma[0].knowledge_level === 0) {
        this.bronzeStars++;
      } else if (this.learntWords[i].lemma.user_lemma[0].knowledge_level === 1) {
        this.silverStars++;
      } else if (this.learntWords[i].lemma.user_lemma[0].knowledge_level >= 2) {
        this.goldStars++;
      }
    }
  },


  computed: {
    ...mapGetters('global', [
        'isMobile', 'profile',
        'states'
    ]),
    ...mapGetters('session', [
        'learntWords'
    ]),
    displaySchadule: function(){
      return !this.profile.datas
    }
  },

  methods: {
    ...mapActions('global', [
        'set_carousselNavTo',
        'set_carousselNavTransition',
        'set_appStep',
        'set_navOpened',
        'update_userDatas'
    ]),
    returnToMenu() {
      this.patchUserInfo()
      this.set_carousselNavTo(1)
      this.set_appStep(this.states.MENU)
      this.set_navOpened(false)
      window.setTimeout( () =>{this.set_carousselNavTransition(true)
      }, 50);
    },

    daySelected: function (id) {
      switch (id) {
        case 0:
          return this.tempProfile.studying_monday
        case 1:
          return this.tempProfile.studying_tuesday
        case 2:
          return this.tempProfile.studying_wednesday
        case 3:
          return this.tempProfile.studying_thursday
        case 4:
          return this.tempProfile.studying_friday
        case 5:
          return this.tempProfile.studying_saturday
        case 6:
          return this.tempProfile.studying_sunday
        default:
          return "";
      }
    },
    dayNames: function (id) {
      switch (id) {
        case 0:
          return "Lun"
        case 1:
          return "Mar"
        case 2:
          return "Mer"
        case 3:
          return "Jeu"
        case 4:
          return "Ven"
        case 5:
          return "Sam"
        case 6:
          return "Dim"
        default:
          return "";
      }
    },
    toggleDay: function (id) {
      switch (id) {
        case 0:
          this.tempProfile.studying_monday = !this.tempProfile.studying_monday;
          break;
        case 1:
          this.tempProfile.studying_tuesday = !this.tempProfile.studying_tuesday;
          break;
        case 2:
          this.tempProfile.studying_wednesday = !this.tempProfile.studying_wednesday;
          break;
        case 3:
          this.tempProfile.studying_thursday = !this.tempProfile.studying_thursday;
          break;
        case 4:
          this.tempProfile.studying_friday = !this.tempProfile.studying_friday;
          break;
        case 5:
          this.tempProfile.studying_saturday = !this.tempProfile.studying_saturday;
          break;
        case 6:
          this.tempProfile.studying_sunday = !this.tempProfile.studying_sunday;
          break;
      }
    },
    patchUserInfo() {
      let payload = {
        "studying_friday":this.tempProfile.studying_friday,
        "studying_monday":this.tempProfile.studying_monday,
        "studying_saturday":this.tempProfile.studying_saturday,
        "studying_sunday":this.tempProfile.studying_sunday,
        "studying_thursday":this.tempProfile.studying_thursday,
        "studying_tuesday":this.tempProfile.studying_tuesday,
        "studying_wednesday":this.tempProfile.studying_wednesday,
        "reminders_ok":this.tempProfile.reminders_ok,
      }
      const url = `${API_URL}/api/auth0user/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.patch(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
        }
        else {
          console.log(error)
        }
      })
      this.update_userDatas(this.tempProfile)
    },
  },

  data() {
    return {
      tempProfile: {},
      goldStars: 0,
      silverStars: 0,
      bronzeStars: 0
    }
  }
}
</script>

<style scoped>
.calendar{
  display: grid;
  grid-template-columns: repeat(7, auto);
  grid-gap: 0.5vw;
}
.studyingDay{
  height: 2vw;
  width: 2vw;
  border-radius: 1vw;
  font-size: 0.8em;
  font-weight: bold;
  background-color: rgba(76,76,76,0.27);
}
.selected{
  color: #ece2cc;
  background-color: #596C3D;
}

.tilePoints{
  font-size: 0.6em;
  display: flex;
  align-content: center;
  align-items: center;
  padding: 0 0.25vw 0 0.25vw;
  background-color: #02020250;
  border-radius: 1vw;
  margin-left: 0.5vw;
}

#obtained{
  font-size: 1.1em;
}
#obtained > *{
  margin-bottom: 0.2vw;
}

.inner {
  display: grid;
  grid-template-rows: auto auto auto auto;
  grid-template-columns: auto;
  justify-content: center;
  justify-items: center;
  align-items: center;
  justify-self: center;
  width: 90%;
  height: calc(100% - 2vw);
  padding: 1vw;
  grid-gap: 1vw;
}

@media screen and (max-device-width: 767px) {
  #obtained{
    font-size: 1.5em;
  }
  #obtained > *{
    margin-bottom: 2vw;
  }
  .calendar{
    grid-gap: 2vw;
    padding: 1.5vw;
  }
  #calendarcard{
    font-size: 1.1em;
  }
  .studyingDay{
    height: 8vw;
    width: 8vw;
    border-radius: 4vw;
  }
}
</style>
